export const HASH_TYPE = 'hashType';
export const DATA_TYPE = 'dataType';
export const CASE = 'caseType';
export const IS_DASHED_INCLUDED = 'isDashesIncluded';
export const IS_VALUE_PROVIDED = 'isValueProvided';
export const IS_BOT_INCLUDED = 'isBotIncluded';
export const INCLUDE = 'include';

export const DATA_TYPE_LAST_UID = 2;
export const HASH_TYPE_NON_HASHED = 0;
export const HASH_TYPE_MD5 = 1;
export const CASE_TYPE = 0;
